<!--<div class="refreshInfo"><span>{{ordersLabel}} Orders as of: {{ordersSupportDetails?.lastUpdated| easternTime | date:'MM/dd/yyyy h:mm a'}} ET.-->
<!--</span> Click <i>Refresh blotter</i> to update Order Statuses-->
<!--  <button class="btn-medium-primary refresh" (click)="refreshGridBtnAction()">-->
<!--    <img src="../../assets/images/autorenew.svg" title="Refresh" width="14" height="14"/>Refresh blotter-->
<!--  </button>-->
<!--</div>-->
<div style="margin-top:8px"></div>
@if (current == 'automatedOrders' && globalSettings && globalSettings?.isAutoRebalanceEnabled) {
  <div>
    @if (globalSettings?.tradeTime && !globalSettings?.isTradingPaused) {
      <div class="message success">
        <div style="margin: 10px 0px;">Automated trading time is set to {{globalSettings.tradeTime}} EST. <a (click)="openGlobalSettings()">Open settings</a></div>
      </div>
    }
    @if (globalSettings?.isTradingPaused) {
      <div class="message warning">
        <div style="margin: 10px 0px;">Automated trading is paused. Trades will not be submitted. <a (click)="openGlobalSettings()">Open settings</a></div>
      </div>
    }
  </div>
}
<div>
  @if (current != 'automatedOrders') {
    <irb-filters-for-grid  #gridPresetFiltersComp (applySelectedGridFilter)="applySelectedGridFilter($event)"
      [filterForGrid]="filterForGrid"
      [applyDefault]="applyDefaultFilter"
    [parentComponentParams]="loadingOverlayComponentParams"></irb-filters-for-grid>
  }
  <irb-filter-chips #filterChipsComp [filterData]="_filterChipModel" [dataMap]="filterDisplayNamesData" (removeFilterItem)="onRemoveFilterItem($event)" [context]="loadingOverlayComponentParams"></irb-filter-chips>
</div>
@if (!isUiTest) {
  <irb-inventory-grid #inventoryGrid id="order-blotter-grid"
    [style.minHeight]="'600px'"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    [sideBar]="sideBar"
    [footerContent] = "footerContent"
    [componentName]="'ordersInventoryComponent' + current + '-v001'"
    [contextMenuItems]="getContextMenuItems()"
    [frameworkComponents]="frameworkComponents"
    [loadingOverlayComponent]="'customLoadingOverlay'"
    [loadingOverlayComponentParams]="loadingOverlayComponentParams"
    [noRowsOverlayComponent]="'customNoRowOverlay'"
    [noRowsOverlayComponentParams]="loadingOverlayComponentParams"
    (cellValueChanged)="onCellValueChanged($event)"
  ></irb-inventory-grid>
}


<ng-template #validateDialogTemplate>
  <div mat-dialog-title><b>Trades Could Not be Exported</b></div>
  <mat-dialog-content>
    @if (validateThinkPipeFormat.notHeldCnt || validateThinkPipeFormat.mutualFundSecTypeCnt) {
      <div  class = "mat-dialog-content" >
        The below trades will not be exported.<br/>
        @if (validateThinkPipeFormat.notHeldCnt) {
          <span>
            {{validateThinkPipeFormat.notHeldCnt }} Not Held Trades
          </span>
        }
        @if (validateThinkPipeFormat.mutualFundSecTypeCnt) {
          <span >
            {{validateThinkPipeFormat.mutualFundSecTypeCnt }}  Mutual Fund Trades
          </span>
        }
      </div>
    }</mat-dialog-content>
    <mat-dialog-actions>
      <button id="closeButton" mat-dialog-close class="btn-medium-secondary">Cancel</button>
      <button id="continueButton" class="btn-medium-primary" (click)="continueExportThinkPipe()">Continue</button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #exportBlockAllocation>
    <div mat-dialog-title><b>Export Orders</b></div>
    <mat-dialog-content>
      There are no block orders. Do you want to continue with this export?
    </mat-dialog-content>
    <mat-dialog-actions>
      <button id="closeButton" mat-dialog-close class="btn-medium-secondary">Cancel</button>
      <button id="continueButton" class="btn-medium-primary" [disabled] = "true">Export</button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #workflowDialogTemplate>
    <div mat-dialog-title>{{workflowDialogData?.title}}<button class="close" mat-button title="Cancel" mat-dialog-close><i class="material-icons clear">clear</i></button></div>
    <mat-dialog-content class="mat-badge-medium">
      <p style="min-width: 300px; max-width: 500px;">{{workflowDialogData?.content}}</p>
      @for (item of workflowDialogData.msgList; track item) {
        @if (item && item.nestedMsgList && item.nestedMsgList.length > 0) {
          <div style="min-width: 300px; max-width: 500px;margin-bottom:0px!important;">
            <p style="min-width: 300px; max-width: 500px;margin-top:0px!important;margin-bottom:5px!important;">
              {{item.msg}}
              <ul class="nested-message-list" style="margin-top:5px;margin-bottom:5px;">
                @for (nestedMsg of item.nestedMsgList; track nestedMsg) {
                  <li  class ="nested-message-list-item">{{nestedMsg}}</li>
                }</ul>
              </div>
            } @else {
              <p style="min-width: 300px; max-width: 500px;">
                {{item}}
              </p>
            }
          }
        </mat-dialog-content>
        <mat-dialog-actions>
          <button id="closeButtonWarningDailog" mat-dialog-close class="btn-medium-secondary">Close</button>
          @if (workflowDialogData?.proceedBtnEnable) {
            <button id="proceedButton" (click)="workflowProceed()" class="btn-medium-primary">Proceed</button>
          }
        </mat-dialog-actions>
      </ng-template>

      <ng-template #viewBlockOrders>
        <div mat-dialog-title><b>Block Order Components</b><button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
        <mat-dialog-content>
          <div class="blockOrderTable">
            <div class="blockOrderHeading">Block Order</div>
            <table><tbody>
              <div class="block">
                <div class="left innerBlock">
                  <div class="block">
                    <div class="left">
                      <div class="innerSubText"><strong>Block Acct#</strong></div>
                      <span>{{blockOrder.accountNumber}}</span>
                    </div>
                    <div class="left blokSubHeadingText">
                      <div class="innerSubText"><strong>Symb</strong></div>
                      <span>{{blockOrder.securitySymbol}}</span>
                    </div>
                    <div class="left blokSubHeadingText">
                      <div class="innerSubText"><strong>Shr Qty</strong></div>
                      <span>{{blockOrder.quantity}}</span>
                    </div>
                    <div class="left blokSubHeadingText">
                      <div class="innerSubText"><strong>Trans Type</strong></div>
                      <span>{{blockOrder.transactionType}}</span>
                    </div>
                    <div class="left blokSubHeadingText">
                      <div class="innerSubText"><strong>Order Amt</strong></div>
                      <span>{{blockOrder.dollarAmount}}</span>
                    </div>
                    <div class="left blokSubHeadingText">
                      <div class="innerSubText"><strong>Order Type</strong></div>
                      <span>{{blockOrder.orderType}}</span>
                    </div>
                    <div class="left blokSubHeadingText">
                      <div class="innerSubText"><strong>Price</strong></div>
                      <span>{{blockOrder.price}}</span>
                    </div>
                    <div class="left blokSubHeadingText">
                      <div class="innerSubText"><strong>Exp Type</strong></div>
                      <span>{{blockOrder.expirationType}}</span>
                    </div>
                    <div class="left blokSubHeadingText">
                      <div class="innerSubText"><strong>Exp Date</strong></div>
                      <span>{{blockOrder.expirationDate}}</span>
                    </div>
                    <div class="left blokSubHeadingText">
                      <div class="innerSubText"><strong>Not Held</strong></div>
                      <span>{{blockOrder.ordIsNotHeld}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </tbody>
          </table>
        </div>

        <div class="block"><strong>Allocation Details</strong></div>

        @if (openGrid) {
          <irb-inventory-grid
            [style.minHeight]="'300px'"
            [gridHeight]="'300px'"
            [showSideBar]="false"
            [componentName]="'blockOrdersInventoryComponent'"
            [gridOptions]="blockOrderGridOptions"
            [columnDefs]="blockOrderGridOptions.columnDefs"
            [rowData]="viewBlockOrder">
          </irb-inventory-grid>
        }
      </mat-dialog-content>
      <!--* The number of shares that will be sold is the number of shares shown in the share quantity column. If the account holds additional shares due to a recent purchase or transfer, these shares will not be sold.-->


      <mat-dialog-actions>
        <button id="closeButtonViewBlock" mat-dialog-close class="btn-medium-primary">Close</button>
      </mat-dialog-actions>
    </ng-template>
    <ng-template #irbProgressBarOrdStatUpdId>
  <div style="
    display: block;
    margin-top: 20px;
  ">
        <irb-progress-bar [progressValue]="ordStatUpdIdprogressBarValue"></irb-progress-bar>
      </div>
    </ng-template>

    <ng-template #orderHistoryTemplate>
      <div mat-dialog-title><button id="clearButtonViewOrder" class="close" mat-button title="Cancel" (click)="closeHistoryDialog()"><i class="material-icons clear">clear</i></button></div>
      <mat-dialog-content>@if (currentOrderData) {
        <irb-order-histroy  [(data)]="currentOrderData" [(inventoryObj)] = "inventoryComponentRef"></irb-order-histroy>
      }</mat-dialog-content>
      <mat-dialog-actions>
        <button id="closeButtonViewOrder" mat-dialog-close class="btn-medium-primary">Close</button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #accountNumberOverlay>
      @if (row) {
        <div>
          <div class="hblock" style="color: #999; font-size: 11px;">Go to SAC</div>
          <div style="padding-left: 10px">
            @for (item of sacMenuItems; track item) {
              <div class="hblock clickable" (click)="openSACWithContext(item.sanc); closeMenu(); $event.stopPropagation();">
                {{item.label}} <i class="material-icons" style="font-size: 16px; color: #666; float: right;">open_in_new</i>
              </div>
            }
          </div>
        </div>
      }
    </ng-template>
